export default {
  DETAIL: 'detail',
  HERO: 'hero',
  TILE: 'tile',
  BILLBOARD: 'billboard',
};
